import { render, staticRenderFns } from "./ProjectAdministration.vue?vue&type=template&id=8ecf4dc0&"
import script from "./ProjectAdministration.vue?vue&type=script&lang=js&"
export * from "./ProjectAdministration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports